<template>
    <settings-page
        v-slot="{ formProcessing, onSubmit }"
        :show="show"
        class="show-settings-directories"
    >
        <directories
            :show="show"
            :form-processing="formProcessing"
            :player-embed="playerEmbed"
            @submit="onSubmit"
        />
    </settings-page>
</template>

<script>
import Directories from '@/components/Shows/Settings/Directories';
import SettingsPage from './SettingsPage';

export default {

    components: {
        Directories,
        SettingsPage,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
        playerEmbed: {
            type: [Boolean, Object],
            default: false,
        },
    },
};
</script>
